// @flow
import React from 'react';
import SecondaryButton from '../../../view/common/component/SecondaryButton';
import NotificationSettingsGuard from '../../notificationSettings/components/NotificationSettingsGuard';
import { getStore } from '../../../state/store';
import markNotificationsAsRead from '../state/markNotificationsAsRead';
import * as AppState from '../../../state/reducer/app/appState';

type Props = {
    disabled: boolean
};

const NotificationsCenterControlBar = ({ disabled }: Props) => {
    const navigateToSettings = () => {
        AppState.navigate('/notification-settings');
    };

    const secondaryButton = (
        <SecondaryButton onClick={navigateToSettings}>
            Notification Settings
        </SecondaryButton>
    );

    return (
        <div className="notifications-control-bar notifications-layout">
            <div className="space-between">
                <SecondaryButton
                    disabled={disabled}
                    onClick={() =>
                        getStore().dispatch(markNotificationsAsRead())
                    }
                >
                    Mark all as read
                </SecondaryButton>
                <NotificationSettingsGuard settingsButton={secondaryButton} />
            </div>
            <div className="spacer" />
        </div>
    );
};

export default NotificationsCenterControlBar;
